import useCompanyBenefits from '@/legacy-src/hooks/useCompanyBenefits'

export const useIsOfflineAllowedByCompany = () => {
  const { quotas, isLoading } = useCompanyBenefits()

  if (isLoading) {
    return false
  }

  const hasActiveCompanyQuota = Boolean(quotas?.length)

  return hasActiveCompanyQuota ? Boolean(quotas?.[0]?.offlineTherapyEnabled) : true
}
